/**
 * Sportconnect — Collection Web Component
 * Snazzy Digital Agency
 *
 * - Toggle du drawer de facets sur mobile
 * - Soumission du form de filtres au changement (debounced)
 * - Soumission du tri au changement
 * - "Voir plus" sans rechargement (concatène les produits suivants)
 */

class SCCollection extends HTMLElement {
  connectedCallback() {
    this.bindFacetsToggle();
    this.bindFacetsForm();
    this.bindSort();
    this.bindLoadMore();
  }

  bindFacetsToggle() {
    const toggle = this.querySelector('[data-facets-toggle]');
    const panel = this.querySelector('[data-facets]');
    const close = this.querySelector('[data-facets-close]');
    if (!toggle || !panel) return;

    const open = () => {
      panel.dataset.open = 'true';
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    const closeFn = () => {
      panel.dataset.open = 'false';
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    toggle.addEventListener('click', () => (panel.dataset.open === 'true' ? closeFn() : open()));
    close?.addEventListener('click', closeFn);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.dataset.open === 'true') closeFn();
    });
  }

  bindFacetsForm() {
    const form = this.querySelector('[data-facets-form]');
    if (!form) return;
    let timeout = null;
    form.addEventListener('change', () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => this.submitFacets(form), 250);
    });
  }

  submitFacets(form) {
    const params = new URLSearchParams();
    form.querySelectorAll('[data-facet-input]').forEach((input) => {
      if (input.type === 'checkbox') {
        if (input.checked) params.append(input.name, input.value);
      } else if (input.value !== '') {
        params.set(input.name, input.value);
      }
    });
    const sort = this.querySelector('[data-sort-select]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    const url = `${window.location.pathname}?${params.toString()}`;
    window.location.href = url;
  }

  bindSort() {
    const sort = this.querySelector('[data-sort-select]');
    if (!sort) return;
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }

  bindLoadMore() {
    const btn = this.querySelector('[data-load-more]');
    if (!btn) return;
    let currentBtn = btn;
    const onClick = async (e) => {
      e.preventDefault();
      const link = currentBtn;
      link.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(link.href);
        const html = await res.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newCards = tmp.querySelectorAll('[data-products-grid] > *');
        const grid = this.querySelector('[data-products-grid]');
        newCards.forEach((c) => grid.appendChild(c));
        const newBtn = tmp.querySelector('[data-load-more]');
        if (newBtn) {
          currentBtn.replaceWith(newBtn);
          currentBtn = newBtn;
          currentBtn.addEventListener('click', onClick);
        } else {
          currentBtn.remove();
        }
      } catch (err) {
        link.removeAttribute('aria-busy');
      }
    };
    btn.addEventListener('click', onClick);
  }
}

if (!customElements.get('sc-collection')) {
  customElements.define('sc-collection', SCCollection);
}
